/* global icimsSpaData */

const useSpaData = () => {
	if (icimsSpaData !== 'undefined') {
		return icimsSpaData;
	}
	return {};
};

export default useSpaData;
